import net from '../../utils/net'
export default {
  // 获取组织树列表
  gettreelist (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 获取企微模糊搜索数据
  getSearchName (methods, url, params, baseUrl) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params, baseUrl)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 获取组织数据列表
  getOrgDataList (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 删除组织数据
  DelOrgDataList (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 获取组织类型列表
  DelOrgTypeDataList (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 添加组织
  AddOrgData (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 添加组织
  EditOrgData (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 获取组织详情
  getOrgDetail (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 店铺转组织
  restoredomain (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 获取人员列表
  getPeopleList (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 删除人员
  DelPersonList (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 重置密码（短信）
  resetpwdsms (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 重置密码（邮件）
  resetpwdmail (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 获取角色列表
  getRolesList (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 获取状态列表
  GetUserStates (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 添加人员
  AddPerson (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 编辑人员
  editPerson (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 获取人员职位列表
  userUplist (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 删除人员职位
  delPosition (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 添加职位
  CreatePosition (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 设置默认职位
  setDefaultPosition (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 获取员工上级列表
  getReporttoList (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 获取国别号列表
  GetInterAreaCode (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 获取用户详情
  getUserDetail (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 获取人员标签列表
  getTagList (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 添加人员标签
  AddPersonData (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 创建人员校验
  Checkcreate (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 恢复已删用户
  UserRecover (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 修改人员标签
  EditPersonData (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 获取人员标签详情
  getpersonTagDetail (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 删除人员标签
  delPersonTag (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 获取人员标签角色列表
  tagRoleList (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 批量删除用户标签关联角色
  delTagRole (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 标签可绑定角色列表
  addTagRoleList (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 用户标签绑定角色
  Createbindroles (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 获取标签相关人员列表
  relationaUserList (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 标签可绑定人员列表
  addpersonList (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 用户标签绑定人员
  CreateRelationaUser (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 店铺标签绑定店铺
  CreateRelationaStore (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 删除相关人员
  delRelationaPerson (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 删除相关店铺
  delRelationaStore (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 组织设定下载模板Excal
  sysdomainDownExcal (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.getBlob(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 按模板导入数据
  importinfoImport (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 组织设定导出Excal
  sysdomainExport (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.getBlob(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 组织类型列表
  getOrgTypeList (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 批量删除组织类型
  deleteOrgType (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 添加组织类型
  addOrgTypeAjax (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 编辑组织类型
  editOrgTypeAjax (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 获取组织类型详情
  getOrgTypeDetailAjax (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 人员下载模板Excal
  UserDownExcal (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.getBlob(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 按模板导入数据人员
  importinfoImportUser (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 人员导出Excal
  userExport (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.getBlob(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 人员职位下载模板Excal
  UserPositionDownExcal (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.getBlob(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 按模板导入数据人员职位
  importinfoImportUserPosition (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 人员职位导出Excal
  userExportPosition (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.getBlob(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 获取角色列表
  GetRoleList (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 获取角色详情
  GetRoleDetail (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 编辑角色
  editRole (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 添加角色
  AddRole (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 删除角色数据
  DelRolesData (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 获取最新的序号
  SortNo (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 获取角色权限列表
  GetRolesAuthorityList (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 批量组织转店铺
  TranslateIntoStoreBatch (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 导出组织列表企微转译
  ExportWXTranslate (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 获取组织导出转译Job结果
  GetWXTranslateURL (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 获取客户关系列表
  getCostumerRelationList (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 添加客户关系
  addCostumerRelation (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 更新客户关系
  updateCostumerRelation (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  deleteCostumerRelation (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 导出人员列表企微转译
  ExportWXTranslateUser (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 导出人员列表企微转译
  ExportWXTranslateUserUdp (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  // 重新同步
  AgainSync (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },

  // 获取店铺字段profile
  getFieldProfile (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  saveFieldProfile (methods, url, params) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  }
}
